/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../Core/Components/CustomTable";
import CustomLayout from "../../Core/Layout/CustomLayout";
import { inventoryColumns } from "./Data/InventoryListData";
import ServiceIcon from "../../Common/Svgs/ServiceIcon";
import { getInventory } from "../../Redux/APIs/inventoryAPI";
import { getUserByEmail } from "../../Redux/APIs/systemUsersAPI";
import { getTableContainerHeight } from "../../Utils/getTableContainerHeight";
import { getAllLocationsV3 } from "../../Redux/APIs/locationsAPI";

function InventoryList() {
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => state.loggedInUser);

  const tableContainerRef = useRef(null);

  useEffect(() => {
    dispatch(getInventory());
  }, [dispatch]);

  // fetch user details and all the locations (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));
    dispatch(getAllLocationsV3());
  }, [dispatch]);

  return (
    <CustomLayout pageName="Inventory">
      <div>
        <div className="h-[calc(100vh-72px-61px-48px)]" ref={tableContainerRef}>
          <CustomTable
            scrollX={0}
            columns={inventoryColumns}
            data={[]}
            emptyState={
              <ServiceIcon className="w-4 h-4 fill-none stroke-dark-grey-text" />
            }
            emptyStateHeight={getTableContainerHeight(tableContainerRef)}
          />
        </div>
      </div>
    </CustomLayout>
  );
}
export default InventoryList;
